import { useEffect, useState } from 'react';
import { codicesApi } from '../lib/api';

// Loads a single codex by id.
export default function useCodex(codexId) {
  const [codex, setCodex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);

    codicesApi
      .getById(codexId, controller.signal)
      .then(setCodex)
      .catch((err) => {
        if (err.name !== 'AbortError') setError(err.message);
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [codexId]);

  return { codex, loading, error };
}
